import { collection, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { Integration } from "../models/Integration";
import { db } from "../firebase";
import { getSubdomainFromUrl } from "../utils/url";

const integrationCollectionRef = (tenantId: string) =>
  collection(db, "tenants", tenantId, "integrations");

export const IntegrationService = {
  async createIntegration(
    integrationData: Omit<Integration, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const newIntegration: Omit<Integration, "_id" | "createdAt" | "updatedAt"> =
      {
        ...integrationData,
      };
    const tenantId = getSubdomainFromUrl(window.location.href);
    const integrationRef = await addDoc(
      integrationCollectionRef(tenantId),
      newIntegration,
    );
    return integrationRef.id;
  },
  async updateIntegration(
    userId: string,
    updatedData: Partial<Omit<Integration, "_id" | "createdAt">>,
  ): Promise<void> {
    const tenantId = getSubdomainFromUrl(window.location.href);
    const userDocRef = doc(integrationCollectionRef(tenantId), userId);
    await setDoc(
      userDocRef,
      {
        ...updatedData,
      },
      { merge: true },
    );
  },
  async deleteIntegrationById(integrationId: string): Promise<void> {
    const tenantId = getSubdomainFromUrl(window.location.href);
    const integrationRef = doc(
      db,
      "tenants",
      tenantId,
      "integrations",
      integrationId,
    );
    await deleteDoc(integrationRef);
  },
};
